import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import {
  ProvidersDetailsBoxStyled,
  ProvidersPremiumBoxStyled,
  ProvidersPremiumTextStyled,
} from '../AddYourProvidersStyled';
import { PsButtonTuner } from '../../../../stencilSetup';
import { PrimaryCarePlanDetails } from '../../Plans/PlanCard/components';
import {
  validatePcpDependents,
  validatePcpEmployee,
} from '../../Plans/PlanCard/utils';
import { AddYourProviderCardDetailsProps } from '../types/dto';
import { selectPerPayPeriodText } from 'enrollment/services';
import { getPremiumStyled, RETURN_VALUE_ONLY } from 'enrollment/utils';

export const AddYourProviderCardDetails = ({
  coverage,
  plan,
  benefit,
  subscriber,
  dependents,
  selectedDependentIds,
  pcpMembers,
  selected,
  isPcpOptional,
  handleElection,
  openChooseProviderDrawer,
  setOpenChooseProviderDrawer,
  setShowPcpDrawer,
  togglePcpDrawer,
  isEsignPlanRequired,
  isFindAProviderEnabled,
  hideDependentCheckboxWhenChecked,
  setHideDependentCheckboxWhenChecked,
  subscribeZipCode,
}: AddYourProviderCardDetailsProps) => {
  const { t } = useTranslation('pages.enrollmentAddProviders');
  const perPayText = useSelector(selectPerPayPeriodText);

  const findProviderEnabled = coverage?.pcp_data?.find_a_provider_enabled;

  const showPrimaryCarePlanDetails =
    coverage?.pcp_data &&
    (benefit?.benefit_lookup_code === 'dental' || 'medical')
      ? true
      : false;

  const handleSearchProvider = () => {
    // Handle search provider logic
    setShowPcpDrawer(true);
  };

  const handleAddProvider = () => {
    // Handle Add provider logic
    setShowPcpDrawer(true);
  };

  const showFindProvider =
    findProviderEnabled &&
    showPrimaryCarePlanDetails &&
    !validatePcpEmployee(pcpMembers) &&
    !validatePcpDependents(pcpMembers);
  const showAddProvider =
    !findProviderEnabled &&
    showPrimaryCarePlanDetails &&
    !validatePcpEmployee(pcpMembers) &&
    !validatePcpDependents(pcpMembers);

  return (
    <>
      <ProvidersDetailsBoxStyled>
        <ProvidersPremiumBoxStyled>
          <ProvidersPremiumTextStyled>
            {getPremiumStyled({
              premium: String(coverage?.req_subscriber_premium),
              valueOnly: RETURN_VALUE_ONLY,
            })}
          </ProvidersPremiumTextStyled>
          <Typography fontSize={16} fontWeight={400}>
            {`${perPayText}`}
          </Typography>
        </ProvidersPremiumBoxStyled>
        <div className="text-center mt-4 mt-md-4">
          {showFindProvider && (
            <PsButtonTuner
              buttonId={`find-a-provider-btn-${coverage?.coverage_id}`}
              data-testid={`find-a-provider-btn-${coverage?.coverage_id}`}
              level="primary"
              label={t('findAProviderBtn')}
              icon="binoculars"
              onClick={handleSearchProvider}
            />
          )}
          {showAddProvider && (
            <PsButtonTuner
              buttonId={`add-provider-btn-${coverage?.coverage_id}`}
              data-testid={`add-provider-btn-${coverage?.coverage_id}`}
              level="primary"
              label={t('addProvider')}
              icon="binoculars"
              onClick={handleAddProvider}
            />
          )}
        </div>
      </ProvidersDetailsBoxStyled>
      {showPrimaryCarePlanDetails && (
        <PrimaryCarePlanDetails
          subscriber={subscriber}
          dependents={dependents}
          selectedDependentIds={selectedDependentIds}
          pcpMembers={pcpMembers}
          selected={selected}
          benefitLookup={benefit?.benefit_lookup_code}
          setPcpElectionData={handleElection}
          togglePcpDrawer={togglePcpDrawer}
          openChooseProviderDrawer={openChooseProviderDrawer}
          setOpenChooseProviderDrawer={setOpenChooseProviderDrawer}
          setShowPcpDrawer={setShowPcpDrawer}
          planId={Number(plan?.plan_id)}
          isPcpOptional={isPcpOptional}
          plan={plan}
          isEsignPlanRequired={isEsignPlanRequired}
          isFindAProviderEnabled={isFindAProviderEnabled}
          hideDependentCheckboxWhenChecked={hideDependentCheckboxWhenChecked}
          setHideDependentCheckboxWhenChecked={
            setHideDependentCheckboxWhenChecked
          }
          isAddProvider={true}
          subscribeZipCode={subscribeZipCode}
          setAllowPcpElection={() => { return; }}
          setPcpDrawerRequired={() => { return; }}
        />
      )}
    </>
  );
};
